export const imgLoader = src => {
    if (src && typeof src === 'string') {
        return src
    }
    return null
}
